import { Component, OnInit, OnDestroy, AfterViewInit, Inject } from '@angular/core';

import { Platform } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService, APP_MODE } from './app.service';
import { DOCUMENT } from '@angular/common';
import { AuthService } from './core-api/services/auth/auth.service';
import { PlatformService } from './core-api/platform/platform.service';
import { STATUS_PERIPHERIQUE } from './app.models';
import { ABWToastService } from './shared/helpers/abw-toast.service';
//import { GlobalErrorHandler } from './shared/errors/global-error-handler';
import { SignalRService } from './core-api/signalr/signalr.service';
import { Router } from '@angular/router';
import { GlobalNotificationsService } from './shared/global-notifications.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  loading = false;
  onComplete = new Subject();

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private platformService: PlatformService,
    public _appService: AppService,
    private _authService: AuthService,
    private _signalrService: SignalRService,
    private _toastService: ABWToastService,
    private _router: Router,
    //private _globalErrorHandler: GlobalErrorHandler,
    private _globalNotificationsService: GlobalNotificationsService, 
    @Inject(DOCUMENT) private _document: Document,
  ) {
    this.initializeApp();
    //this._globalErrorHandler.setupTraceLogConsole();
  }

  ngOnInit() {
    this._authService.authenticationState$.pipe(takeUntil(this.onComplete)).subscribe(_isAuthenticated => {
      if (this._signalrService.isConnected()) {
        if (_isAuthenticated) {
          const authSession = this._authService.AuthSession;
          this._signalrService.authenticate(authSession.User.ID, authSession.User.SOCIETE_ID);
        } else {
          this._signalrService.unauthenticate();
        }
      }
    });
    this._signalrService.doConnectHub().then(() => {
      const isAuthenticated = this._authService.authenticationState$.value;
      if (isAuthenticated) {
        const authSession = this._authService.AuthSession;
        this._signalrService.authenticate(authSession.User.ID, authSession.User.SOCIETE_ID);
      } else {
        this._signalrService.unauthenticate();
      }
    });
  }

  async ngAfterViewInit() {
    if (this._appService.AppMode == APP_MODE.OFFLINE_MODE && !this._document.body.classList.contains('app-offline')) {
      this._document.body.classList.add('app-offline');
    } else if (this._document.body.classList.contains('app-offline')) {
      this._document.body.classList.remove('app-offline');
    }

    if ((this._appService.AppMode == APP_MODE.ONLINE_MODE || this._appService.AppMode === undefined) && this.platformService.isAndroidApp()) {
      await this._doCheckStatusPeripheriqueAction();
    }
  }

  ngOnDestroy() {
    this.onComplete.next();
    this.onComplete.complete();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.statusBar.styleLightContent();
      this.splashScreen.hide();
    });
  }

  private async _doCheckStatusPeripheriqueAction() {
    this.loading = true;
    setTimeout(async () => {
      const deviceInfos = await this.platformService.getDeviceInfos();
      try {
        const statusPeripherique = await this._appService.doCheckStatusPeripheriqueAction(deviceInfos);
        if (statusPeripherique == STATUS_PERIPHERIQUE.REGISTERED) {
          this._toastService.showToast("Aucun profil n'est associé à ce périphérique. Une demande a été soumise.", "Abworkflow");
        }
        this.loading = false;
      } catch(ex) {
        console.error('FAIL TO REGISTER DEVICE', ex.message);
        this.loading = false;
      }
    }, 5000);
  }
}
